// client/src/pages/resource/ReservationView.js
import React, { useContext, useRef, useState } from 'react';
import { AuthContext } from '../../context/AuthContext.js';
import TodoRegisterLayer from '../../components/todo/TodoRegisterLayer';
import { TODO_REF_TYPE, TODO_REF_TABLE } from '../../api/todoApi';

function ReservationView({ reservation, actions }) {
  // 모든 Hook은 무조건 최상단에서 호출
  const { user } = useContext(AuthContext);
  const [showTodoLayer, setShowTodoLayer] = useState(false);
  const todoRegBtnRef = useRef(null);

  // reservation이 없으면 early return (hook 이후)
  if (!reservation) return null;

  console.log('[진단] ReservationView reservation:', reservation);

  // 권한 체크
  const isAdmin = user?.role === 'admin';
  const isOwner = user?.userid === reservation.writerId;
  const isApprover = user?.userid === reservation.approverId;
  const isResourceAdmin = user?.userid === reservation.approverId; // 임시로 approverId 사용

  // 시간 포맷 함수 (초 제거)
  const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const [h, m] = timeStr.split(':');
    return `${h}:${m}`;
  };

  return (
    <div className="container-fluid reservation-view">
      {/* 상단 제목 + 작성자/작성일 */}
      <div className="mb-3 border-bottom pb-2">
        <h4 className="fw-bold mb-2">{reservation.subject}</h4>
        <div className="text-muted small">
          <h6>
            작성자: {reservation.writerName} ({reservation.writerId}) &nbsp;|&nbsp;
            작성일: {new Date(reservation.createdAt).toLocaleString('ko-KR')}
          </h6>
        </div>
      </div>

      {/* 예약 정보 카드 */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-md-6">
              <strong>예약일시 : </strong>{reservation.resStartDate} {formatTime(reservation.resStartTime)} ~ {reservation.resEndDate} {formatTime(reservation.resEndTime)}
            </div>
            <div className="col-md-6"><strong>상태 : </strong> {reservation.status}</div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6"><strong>구분 : </strong> {reservation.resCategory}</div>
            <div className="col-md-6"><strong>자원 : </strong> {reservation.resName}</div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6"><strong>인원 : </strong> {reservation.memberCount ?? '미입력'} 명</div>
            <div className="col-md-6">
              <strong>색상 : </strong>
              <div
                style={{
                  display: 'inline-block',
                  minWidth: '100px',
                  padding: '2px 10px',
                  backgroundColor: reservation.resColor,
                  color: '#ffffff',
                  fontWeight: 'bold',
                  borderRadius: '4px',
                  marginLeft: '8px',
                  textAlign: 'center'
                }}
              >
                {reservation.resColor}
              </div>
            </div>
          </div>

          {/* 자원관리자 표시 */}
          <div className="row mb-2">
            <div className="col-12">
              <strong>자원관리자 : </strong>
              {reservation.approverName} ({reservation.approverId})
            </div>
          </div>
          
          <div className="row">
            <div className="col-12">
              <strong>요청사항</strong>
              <div
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  height: '70px',
                  overflowY: 'auto',
                  padding: '8px',
                  whiteSpace: 'pre-line',
                  backgroundColor: '#fdfdfd'
                }}
              >
                {reservation.comment || ''}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 버튼 영역 */}
      <div className="d-flex justify-content-between gap-1" style={{ position: 'relative' }}>
        <div style={{ position: 'relative' }}>
          <button
            ref={todoRegBtnRef}
            type="button"
            className="btn btn-outline-success"
            onClick={() => setShowTodoLayer((prev) => !prev)}
          >
            To-Do 등록
          </button>
          {showTodoLayer && (
            <TodoRegisterLayer
              direction="up"
              source={{
                ref_type: TODO_REF_TYPE.RESOURCE,
                ref_table: TODO_REF_TABLE.RESOURCE,
                ref_id: reservation.id,
                title: reservation.subject,
              }}
              anchorRef={todoRegBtnRef}
              onClose={() => setShowTodoLayer(false)}

            />
          )}
        </div>

        <div className="d-flex justify-content-end gap-1">
        {/* 작성자, 승인자, 관리자, 자원 관리자만 수정/삭제 가능 → 대기 상태일 때만 */}
        {(reservation.status === '대기') && (isAdmin || isOwner || isApprover) && (
          <>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => actions.edit(reservation)}
            >
              수정
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => actions.delete(reservation)}
            >
              삭제
            </button>
          </>
        )}

        {/* 관리자 또는 자원 관리자만 승인/반려 가능 → 대기 상태일 때만 */}
        {(reservation.status === '대기') && (isAdmin || isResourceAdmin) && (
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => actions.approve(reservation)}
            >
              승인
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => actions.reject(reservation)}
            >
              반려
            </button>
          </>
        )}

        {/* ✅ 반려 상태일 때만 반려 의견 보기 버튼 추가 */}
        {(reservation.status === '반려') && (isAdmin || isOwner || isApprover) && (
          <button
            type="button"
            className="btn btn-outline-danger"
            onClick={() => actions.viewReject(reservation)}
          >
            반려의견
          </button>
        )}

        {/* 닫기 버튼은 항상 표시 */}
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={actions.close}
        >
          닫기
        </button>
        </div>
      </div>
    </div>
  );
}

export default ReservationView;
